import { Box } from '@chakra-ui/react';

import { Condition, Iteration } from 'Component/others';
import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const ColumnBarcodePromo = ({ value }) => {
  return (
    <Box className={styles['column-barcode-promo__container']}>
      <Condition
        statement={value && value.length > 0}
        fallback={
          <Box className={styles['column-barcode-promo__box']}>
            <TextRegular className={styles['column-barcode-promo__text']}>-</TextRegular>
          </Box>
        }
      >
        <Iteration
          items={value.filter((_, index) => index < 2)}
          render={(product, index) => {
            const isFirstColumn = index === 0 && value?.length > 1;
            const isLastColumn = index === 1;
            return (
              <Box
                className={`${styles['column-barcode-promo__box']} 
                ${isFirstColumn && styles['column-barcode-promo__box--first']} 
                ${isLastColumn && styles['column-barcode-promo__box--last']}`}
              >
                <TextRegular className={styles['column-barcode-promo__text']}>{product.sku}</TextRegular>
              </Box>
            );
          }}
        />
      </Condition>
    </Box>
  );
};

export default ColumnBarcodePromo;
